import React from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Tooltip from "../Tooltip";

const InformationTooltip = ({ title }) => {
  return (
    <Tooltip title={title}>
      <InfoOutlinedIcon htmlColor="#fff" />
    </Tooltip>
  );
};

export default InformationTooltip;
